import { useEffect, useRef, useState } from "react";

import {

  Table,

  Button,

  Row,

  Col,

  Card,

  Spin,

  Select,

  Input,

  message,

  Modal,

  Tooltip,

  Pagination,

  DatePicker,

  Tag,

  Dropdown,

  Radio,

  Form,

} from "antd";

import {

  CheckCircleTwoTone,

  ClockCircleOutlined,

  CloseCircleTwoTone,

  MessageOutlined,

  SearchOutlined,

  UserOutlined,

  DollarOutlined,

} from "@ant-design/icons";

import { RiAddBoxFill } from "react-icons/ri";

import { FcMoneyTransfer } from "react-icons/fc";

import { ColumnType } from "antd/es/table";

import { FaCopy, FaDownload, FaPen, FaTrashAlt } from "react-icons/fa";

import { hasPermission } from "../../utils/HasPermission";

import {

  deleteInvoice,

  deleteReceipts,

  exportReceiptsExcel,

  getAllInvoice,

  getAllReceipts,

  getAllReceiptsForAmounts,

  getInvoiceLog,

  getReceiptsLog,

  sendInvoiceEmail,

  updateInvoice,

  getEmailTemplateBySlug,

  getEmailMetadata,

} from "../../utils/API";

import dayjs from "dayjs";

import customParseFormat from "dayjs/plugin/customParseFormat";

import { BiExport } from "react-icons/bi";

import AddInvoicePage from "./AddInvoicePage";

//import AddInvoiceModel from "./Add";

import EditInvoiceModel from "./Edit";

import { downloadInvoicePdf } from "../../utils/invoicePdf";

import CopyInvoiceModel from "./Copy";

import axios from "axios";

import AddInvoiceModel from "./Add";

import { useNavigate } from "react-router-dom";

import Tab from "react-bootstrap/Tab";

import Tabs from "react-bootstrap/Tabs";

import {

  buildDraftDisplayNumberMap,

  getInvoiceSequence,

  hasInvoiceAutoDraftActivity,

  clearInvoiceAutoDraftCompleted,

} from "../../utils/invoiceNumber";

import AddReceiptsModel from "../Receipts/AddReceiptsModel";



dayjs.extend(customParseFormat);



const { Option } = Select;



interface InvoiceRecord {

  key: string;

  _id: string;

  invoice_number: string;

  customer_name: string;

  custom_customer_name?: string;

  grand_total: number;

  currency: string;

  invoice_date: string;

  due_date: string;

  description: string;

  email?: string;

  invoice_status?: string;

  createdAt?: string;

  updatedAt?: string;

}



const InvoicePage = () => {

  const navigate = useNavigate();



  const [selectedRowKeys, setSelectedRowKeys] = useState<string[]>([]);

  const [searchText, setSearchText] = useState("");

  const [loading, setLoading] = useState(false);

  const [savedPage, setSavedPage] = useState(1);

  const [draftPage, setDraftPage] = useState(1);

  const [totalRecords, setTotalRecords] = useState(0);

  const [dropdownsClosed, setDropdownsClosed] = useState(0);

  //const [isModelOpen, setIsModelOpen] = useState(false);

  // const [receiptsModel, setReceiptsModel] = useState(false);

  const [currentTask, setCurrentTask] = useState<InvoiceRecord | null>(null);

  const [sendEmailRecord, setSendEmailRecord] = useState<InvoiceRecord | null>(

    null,

  );

  const [isEditModalVisible, setIsEditModalVisible] = useState(false);

  const [isCopyModalVisible, setIsCopyModalVisible] = useState(false);

  const [filteredMethod, setFilteredMethod] = useState("");

  const [dataSource, setDataSource] = useState<InvoiceRecord[]>([]);

  const [deleteId, setDeleteId] = useState<string | null>(null);

  const [isLogModalOpen, setIsLogModalOpen] = useState(false);

  const [logLoading, setLogLoading] = useState(false);

  const modalScrollRef = useRef<HTMLDivElement>(null);

  const [selectedInvoiceLogs, setSelectedInvoiceLogs] = useState<any[]>([]);

  const [logsPagination, setLogsPagination] = useState({

    current: 1,

    pageSize: 5,

    total: 0,

  });

  const [currentInvoiceLogId, setCurrentInvoiceLogId] = useState<string | null>(

    null,

  );

  const [logSearchText, setLogSearchText] = useState("");

  const [selectedMonth, setSelectedMonth] = useState<dayjs.Dayjs | null>(null);

  const [exporting, setExporting] = useState(false);

  const [updatingInvoiceId, setUpdatingInvoiceId] = useState<string | null>(

    null,

  );

  const [isEmailModalVisible, setIsEmailModalVisible] = useState(false);

  const [emailModalLoading, setEmailModalLoading] = useState(false);

  const [emailForm] = Form.useForm();

  const [selectedEmailTemplate, setSelectedEmailTemplate] = useState<any>(null);

  const [emailPreview, setEmailPreview] = useState<{

    subject: string;

    body: string;

  } | null>(null);

  const [emailTemplateLoading, setEmailTemplateLoading] = useState(false);

  const [emailTemplateError, setEmailTemplateError] = useState<string | null>(

    null,

  );

  const [activeTab, setActiveTab] = useState<"saved" | "draft">("saved");

  const [selectedStatusFilter, setSelectedStatusFilter] = useState<string>("");

  const [invoiceForReceipt, setInvoiceForReceipt] = useState<any | null>(null);

  const [addReceiptVisible, setAddReceiptVisible] = useState(false);



  // Function to get currency color

  const getCurrencyColor = (currency: string) => {

    switch (currency?.toUpperCase()) {

      case "USD":

        return "#10b981"; // green

      case "EUR":

        return "#3b82f6"; // blue

      case "GBP":

        return "#8b5cf6"; // purple

      case "INR":

        return "#f59e0b"; // amber

      case "JPY":

        return "#ef4444"; // red

      default:

        return "#6b7280"; // gray

    }

  };



  // Function to get currency background color (lighter version)

  const getCurrencyBgColor = (currency: string) => {

    switch (currency?.toUpperCase()) {

      case "USD":

        return "#d1fae5"; // light green

      case "EUR":

        return "#dbeafe"; // light blue

      case "GBP":

        return "#ede9fe"; // light purple

      case "INR":

        return "#fef3c7"; // light amber

      case "JPY":

        return "#fee2e2"; // light red

      default:

        return "#f3f4f6"; // light gray

    }

  };



  // Function to format amount

  const formatAmount = (grand_total: number) => {

    return new Intl.NumberFormat("en-IN").format(Math.floor(grand_total));

  };



  const getCurrencySymbol = (currency: string = "") => {

    const currencyCheck = currency.toUpperCase();



    if (currencyCheck.includes("USD")) return "$";

    if (currencyCheck.includes("EUR")) return "\u20AC";

    if (currencyCheck.includes("INR")) return "\u20B9";



    return currency ? currency + " " : "";

  };



  const getOriginalCurrencyAmount = (record: any) => {

    if (

      !record ||

      !record.currency ||

      record.currency.toUpperCase().includes("INR")

    ) {

      return null;

    }



    return Number(record?.grand_total || 0);

  };



  const getInrCurrencyAmount = (record: any) => {

    if (!record) {

      return 0;

    }



    if (!record.currency || record.currency.toUpperCase().includes("INR")) {

      return Number(record?.grand_total || 0);

    }



    const convertedAmount = Number(

      record?.currency_conversion?.converted_inr_amount,

    );

    if (!Number.isNaN(convertedAmount) && convertedAmount > 0) {

      return convertedAmount;

    }



    const exchangeRate = Number(record?.currency_conversion?.exchange_rate);

    const grandTotal = Number(record?.grand_total || 0);



    if (!Number.isNaN(exchangeRate) && exchangeRate > 0) {

      return grandTotal * exchangeRate;

    }



    return grandTotal;

  };



  // Function to close all dropdowns

  const closeAllDropdowns = () => {

    setDropdownsClosed((prev) => prev + 1);

  };



  const resetSettings = () => {

    // setSelectedSource([]);

    // setTimeFilter(undefined);

    // setStartDate(null);

    // setEndDate(null);

    // setTempStartDate(null);

    // setShowRangePicker(false);

    // setSelectedStatus([]);

    // setFavName("");

    // setError("");

  };



  const editInvoice = (record: InvoiceRecord) => {

    setCurrentTask(record);

    setIsEditModalVisible(true);

    fetchInvoice();

  };



  const copyInvoice = (record: InvoiceRecord) => {

    setCurrentTask(record);

    setIsCopyModalVisible(true);

    fetchInvoice();

  };



  const TwoLineClampWithTooltip = ({ text }: { text: string }) => {

    const textRef = useRef<HTMLDivElement>(null);

    const [isOverflowing, setIsOverflowing] = useState(false);



    useEffect(() => {

      const el = textRef.current;

      if (!el) return;



      const lineHeight = parseFloat(getComputedStyle(el).lineHeight);

      const maxHeight = lineHeight * 2;



      // Detect overflow

      if (el.scrollHeight > maxHeight + 1) {

        setIsOverflowing(true);

      } else {

        setIsOverflowing(false);

      }

    }, [text]);



    const content = (

      <div

        ref={textRef}

        className="line-clamp-2 text-gray-800 cursor-pointer"

        dangerouslySetInnerHTML={{ __html: text }}

      />

    );



    return isOverflowing ? (

      <Tooltip

        title={

          <div

            className="max-h-[250px] overflow-y-auto p-2"

            dangerouslySetInnerHTML={{ __html: text }}

          />

        }

        placement="top"

        color="#CCCCCC"

        overlayInnerStyle={{

          color: "#000",

          padding: "12px",

          maxWidth: "500px",

          minWidth: "400px",

          maxHeight: "400px",

        }}

      >

        {content}

      </Tooltip>

    ) : (

      content

    );

  };



  const fetchInvoice = async () => {

    setLoading(true);



    try {

      // API call

      const response = await getAllInvoice(

        1,

        true,

        searchText,

        selectedMonth ? selectedMonth.format("MM") : undefined,

        selectedMonth ? selectedMonth.format("YYYY") : undefined,

      );



      // supports both response formats

      const invoices = response?.data?.data || response?.data || [];



      if (Array.isArray(invoices)) {

        const sortedData = [...invoices].sort((a: any, b: any) => {

          const aSeq = getInvoiceSequence(a?.invoice_number) ?? 0;

          const bSeq = getInvoiceSequence(b?.invoice_number) ?? 0;



          if (bSeq !== aSeq) {

            return bSeq - aSeq;

          }



          return (

            new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()

          );

        });



        const enrichedData = await Promise.all(

          sortedData.map(async (invoice: any, index: number) => {

            // FIXED: Use the grand_total that's already stored in the invoice

            // instead of recalculating from items

            const totalAmount = Number(invoice.grand_total) || 0;



            // Description from items

            const description =

              invoice?.items

                ?.map((item: any) => {

                  const itemDescription = String(

                    item?.description || "",

                  ).trim();

                  if (!itemDescription) return null;



                  const itemAmount = Number(

                    item?.originalAmount ?? item?.amount ?? 0,

                  );

                  return `${itemDescription} - ${formatAmount(itemAmount)}`;

                })

                .filter(Boolean)

                .join("<br/>") || "N/A";



            return {

              ...invoice,

              serialNumber: index + 1,

              grand_total: totalAmount, // Now this will show the GST-inclusive amount

              description: description,

              invoice_status: invoice.invoice_status || "drafted",

            };

          }),

        );



        console.log("Invoices Loaded:", enrichedData);



        setDataSource(enrichedData);

        setTotalRecords(enrichedData.length);

      } else {

        setDataSource([]);

        setTotalRecords(0);

        message.error("Invalid invoice data format");

      }

    } catch (error) {

      console.error("Error fetching invoices:", error);

      message.error("Error fetching invoices. Please try again.");

    } finally {

      setLoading(false);

    }

  };



  const handleDelete = async () => {

    if (deleteId) {

      try {

        const response: any = await deleteInvoice(deleteId);

        // console.log("Delete Response:", response); // Debugging log

        fetchInvoice(); // Refresh list



        if (response?.success) {

          message.success("Invoice deleted successfully");

        } else {

          // message.error(response?.message || "Failed to delete receipts");

        }

      } catch (error) {

        console.error("Delete Error:", error);

        message.error("Error deleting invoice. Please try again.");

      } finally {

        setDeleteId(null);

      }

    }

  };



  const handleViewInvoiceLogs = async (

    invoiceId: string,

    page = 1,

    search = "",

  ) => {

    try {

      setCurrentInvoiceLogId(invoiceId);

      setIsLogModalOpen(true);

      setLogLoading(true);

      let type = "Invoice";



      const data = await getInvoiceLog(

        invoiceId,

        page,

        logsPagination.pageSize,

        search,

        type,

      );



      // console.log("log:", data);



      setSelectedInvoiceLogs(data.logs);

      setLogsPagination((prev) => ({

        ...prev,

        current: page,

        total: data.pagination.total,

        pageSize: data.pagination.pageSize,

      }));



      // scroll to top of modal

      setTimeout(() => {

        modalScrollRef.current?.scrollTo({ top: 0, behavior: "smooth" });

      }, 100);

    } catch (error) {

      console.error("Failed to fetch invoice logs:", error);

    } finally {

      setLogLoading(false);

    }

  };



  const handleSendInvoiceEmail = async (record: any) => {

    setSendEmailRecord(record);

    setEmailTemplateLoading(true);

    setEmailTemplateError(null);

    setSelectedEmailTemplate(null);

    setEmailPreview(null);



    emailForm.setFieldsValue({

      to: record.email || record.customer_email || "",

      cc: "", // Clear CC field for each new send

      reminderType: "standard",

    });

    setIsEmailModalVisible(true);



    // Auto-load standard template

    try {

      const response = await getEmailTemplateBySlug("standard-email-template");

      if (response?.data) {

        setSelectedEmailTemplate(response.data);

        const preview = generateEmailPreview(response.data, record);

        setEmailPreview(preview);

        setEmailTemplateError(null);

      } else {

        setEmailTemplateError("Template not found");

      }

    } catch (error: any) {

      console.error("Error loading standard template:", error);

      setEmailTemplateError(

        error?.response?.data?.message || "Failed to load email template",

      );

    } finally {

      setEmailTemplateLoading(false);

    }

  };



  const handleConfirmEmailSend = async (values: any) => {

    if (!sendEmailRecord) return;



    try {

      setEmailModalLoading(true);

      message.loading({ content: "Sending email...", key: "sendEmail" });



      await sendInvoiceEmail(

        sendEmailRecord._id,

        values.to,

        values.cc,

        values.reminderType,

      );



      message.success({

        content: "Invoice email sent successfully",

        key: "sendEmail",

      });

      setIsEmailModalVisible(false);

      setSendEmailRecord(null);

      setSelectedEmailTemplate(null);

      setEmailPreview(null);

    } catch (error: any) {

      message.error({

        content: error?.response?.data?.message || "Failed to send email",

        key: "sendEmail",

      });

    } finally {

      setEmailModalLoading(false);

    }

  };



  // Replace dynamic placeholders with actual invoice data

  const generateEmailPreview = (template: any, invoice: any) => {

    if (!template || !invoice) return { subject: "", body: "" };



    let subject = template.subject || "";

    let body = template.body || "";



    // Get customer name

    const customerName = getCustomerDisplayName(invoice.customer_name, invoice);



    // Format amount with currency

    const formatAmount = (amount: number) => {

      return new Intl.NumberFormat("en-IN").format(Math.floor(amount));

    };



    const getCurrencySymbol = (currency: string = "") => {

      const currencyCheck = currency.toUpperCase();

      if (currencyCheck.includes("USD")) return "$";

      if (currencyCheck.includes("EUR")) return "€";

      if (currencyCheck.includes("INR")) return "₹";

      return currency ? currency + " " : "";

    };



    const currencySymbol = getCurrencySymbol(invoice.currency || "");

    const formattedAmount = formatAmount(invoice.grand_total || 0);



    // Replace placeholders

    const replacements: Record<string, string> = {

      "{{invoiceNumber}}": invoice.invoice_number || "",

      "{{customerName}}": customerName,

      "{{grandTotal}}": `${currencySymbol}${formattedAmount}`,

      "{{currency}}": invoice.currency || "",

      "{{invoiceDate}}": invoice.invoice_date

        ? dayjs(invoice.invoice_date).format("DD MMM YYYY")

        : "",

      "{{dueDate}}": invoice.due_date

        ? dayjs(invoice.due_date).format("DD MMM YYYY")

        : "",

      "{{invoiceStatus}}": invoice.invoice_status || "",

      "{{description}}": invoice.description || "",

    };



    Object.keys(replacements).forEach((key) => {

      const regex = new RegExp(key, "g");

      subject = subject.replace(regex, replacements[key]);

      body = body.replace(regex, replacements[key]);

    });



    return { subject, body };

  };



  // Get email template slug based on reminder type

  const getEmailTemplateSlug = (reminderType: string) => {

    switch (reminderType) {

      case "standard":

        return "standard-email-template";

      case "first":

        return "first-payment-reminder";

      case "second":

        return "second-payment-reminder";

      default:

        return "standard-email-template";

    }

  };



  // Fetch email template when reminder type changes

  const handleEmailTypeChange = async (reminderType: string) => {

    if (!sendEmailRecord) return;



    setEmailTemplateLoading(true);

    setEmailTemplateError(null);



    try {

      const slug = getEmailTemplateSlug(reminderType);

      const response = await getEmailTemplateBySlug(slug);



      if (response?.data) {

        setSelectedEmailTemplate(response.data);

        const preview = generateEmailPreview(response.data, sendEmailRecord);

        setEmailPreview(preview);

        setEmailTemplateError(null);

      } else {

        setEmailTemplateError("Template not found");

        setSelectedEmailTemplate(null);

        setEmailPreview(null);

      }

    } catch (error: any) {

      console.error("Error fetching email template:", error);

      setEmailTemplateError(

        error?.response?.data?.message || "Failed to load email template",

      );

      setSelectedEmailTemplate(null);

      setEmailPreview(null);

    } finally {

      setEmailTemplateLoading(false);

    }

  };



  const getCustomerDisplayName = (customer: any, record: any) => {

    if (record?.custom_customer_name) {

      return record.custom_customer_name;

    }



    if (customer && typeof customer === "object" && customer.name) {

      return customer.name;

    }



    if (customer && typeof customer === "string") {

      if (customer.length === 24 && /^[0-9a-fA-F]{24}$/.test(customer)) {

        return "N/A";

      }

      return customer;

    }



    if (

      record?.customer_id &&

      typeof record.customer_id === "object" &&

      record.customer_id.name

    ) {

      return record.customer_id.name;

    }



    return "N/A";

  };



  const invoiceStatusOptions = ["drafted", "sent", "cleared"] as const;



  const getInvoiceStatusStyles = (status?: string) => {

    const statusText = (status || "drafted").toLowerCase();



    switch (statusText) {

      case "drafted":

        return { color: "#F59E0B", bgColor: "#FEF3C7", label: "Drafted" };

      case "sent":

        return { color: "#D97706", bgColor: "#FEF3C7", label: "Sent" };

      case "cleared":

        return { color: "#10B981", bgColor: "#D1FAE5", label: "Cleared" };

      default:

        return {

          color: "#6B7280",

          bgColor: "#F3F4F6",

          label: status || "Drafted",

        };

    }

  };



  const renderInvoiceStatusTag = (status?: string) => {

    const { color, bgColor, label } = getInvoiceStatusStyles(status);



    return (

      <Tag

        style={{

          backgroundColor: bgColor,

          color: color,

          border: "none",

          fontWeight: 500,

          padding: "2px 12px",

          borderRadius: "20px",

          fontSize: "12px",

          marginInlineEnd: 0,

        }}

      >

        {label}

      </Tag>

    );

  };



  const handleInvoiceStatusChange = async (

    record: any,

    nextStatus: (typeof invoiceStatusOptions)[number],

  ) => {

    if (

      !invoiceStatusOptions.includes(nextStatus) ||

      updatingInvoiceId === record._id

    ) {

      return;

    }



    const previousStatus = record.invoice_status || "drafted";



    setUpdatingInvoiceId(record._id);

    setDataSource((prev) =>

      prev.map((item: any) =>

        item._id === record._id

          ? {

              ...item,

              invoice_status: nextStatus,

              updatedAt: new Date().toISOString(),

            }

          : item,

      ),

    );



    try {

      await updateInvoice(record._id, { invoice_status: nextStatus });

      message.success(`Invoice status updated to ${nextStatus}`);

    } catch (error: any) {

      setDataSource((prev) =>

        prev.map((item: any) =>

          item._id === record._id

            ? { ...item, invoice_status: previousStatus }

            : item,

        ),

      );

      message.error(

        error?.response?.data?.message ||

          error?.message ||

          "Failed to update invoice status",

      );

    } finally {

      setUpdatingInvoiceId(null);

    }

  };



  // Columns for the Ant Design Table

  const columns: ColumnType<InvoiceRecord>[] = [

    {

      title: "#",

      key: "index",

      fixed: "left" as const,

      width: 60,

      align: "center" as const,

      render: (_: any, __: any, index: number) => (

        <span style={{ fontWeight: 500, color: "#4B5563" }}>

          {((activeTab === "draft" ? draftPage : savedPage) - 1) * 10 +

            index +

            1}

        </span>

      ),

    },

    {

      title: activeTab === "draft" ? "Draft Number" : "Invoice Number",

      dataIndex: "invoice_number",

      key: "invoice_number",

      fixed: "left" as const,

      width: 150,

      render: (text: string, record: any, index: number) => (

        <div className="flex flex-col gap-1 w-full">

          <span

            style={{

              fontWeight: 600,

              fontSize: "13px",

              color: "#1F2937",

            }}

          >

            {activeTab === "draft"

              ? `DRF-${dayjs().format("YYYY")}-${String(

                  draftDisplayNumberMap.get(record._id) ?? 0,

                ).padStart(4, "0")}`

              : text || "N/A"}

          </span>



          <a

            href="#"

            onClick={(e) => {

              e.preventDefault();

              e.stopPropagation();

              setInvoiceForReceipt(record);

            }}

            style={{

              fontSize: "13px",

              color: "#10B981",

              textDecoration: "underline",

              display: "inline-block",

            }}

            className="hover:text-emerald-700 transition-colors duration-200"

          >

            Add to Receipt

          </a>

        </div>

      ),

    },

    {

      title: "Customer Name",

      dataIndex: "customer_name",

      key: "customer_name",

      width: 150,

      render: (customer: any, record: any) => {

        const customerName = getCustomerDisplayName(customer, record);



        return (

          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>

            <UserOutlined style={{ color: "#6B7280", fontSize: "14px" }} />

            <span

              style={{

                fontWeight: 500,

                color: "#1F2937",

              }}

            >

              {customerName}

            </span>

          </div>

        );

      },

    },

    {

      title: "Amount",

      dataIndex: "grand_total",

      key: "grand_total",

      width: 120,

      align: "right" as const,

      render: (text: number, record: any) => {

        const originalAmount = getOriginalCurrencyAmount(record);

        const inrAmount = getInrCurrencyAmount(record);

        const currencySymbol = getCurrencySymbol(record?.currency || "");

        const isForeignCurrency = originalAmount !== null;



        return (

          <div

            style={{

              display: "flex",

              flexDirection: "column",

              alignItems: "flex-end",

              gap: "2px",

            }}

          >

            <span

              style={{

                fontWeight: 600,

                color: "#10b981",

              }}

            >

              {currencySymbol}{" "}

              {formatAmount(isForeignCurrency ? originalAmount : text)}

            </span>

            <span

              style={{

                fontSize: "11px",

                fontWeight: 600,

                color: "#374151",

                whiteSpace: "nowrap",

              }}

            >

              {"\u20B9"} {formatAmount(inrAmount)}

            </span>

          </div>

        );

      },

      sorter: (a: InvoiceRecord, b: InvoiceRecord) =>

        a.grand_total - b.grand_total,

    },

    {

      title: "Currency",

      dataIndex: "currency",

      key: "currency",

      width: 100,

      align: "center" as const,

      render: (text: string) => {

        const currencySymbol = getCurrencySymbol(text || "");

        // Safely uppercase the string to check for the currency code

        const currencyCheck = text?.toUpperCase() || "";



        // Default styles (Gray)

        let bgColor = "#F3F4F6";

        let textColor = "#4B5563";

        let borderColor = "#E5E7EB";



        // Use .includes() because your data includes symbols like "₹ INR"

        if (currencyCheck.includes("USD")) {

          bgColor = "#F0FDF4";

          textColor = "#16A34A";

          borderColor = "#BBF7D0";

        } else if (currencyCheck.includes("EUR")) {

          bgColor = "#EFF6FF";

          textColor = "#2563EB";

          borderColor = "#BFDBFE";

        } else if (currencyCheck.includes("INR")) {

          bgColor = "#FFFBEB";

          textColor = "#D97706";

          borderColor = "#FDE68A";

        }



        return (

          <div

            style={{

              display: "inline-flex",

              alignItems: "center",

              justifyContent: "center",

              backgroundColor: bgColor,

              color: textColor,

              border: "1px solid",

              padding: "4px 12px",

              borderRadius: "20px",

              fontWeight: 600,

              fontSize: "12px",

              letterSpacing: "0.5px",

            }}

          >

            {text

              ? text.includes(currencySymbol)

                ? text

                : `${currencySymbol} ${text}`.trim()

              : "N/A"}

          </div>

        );

      },

    },

    {

      title: "Invoice Date",

      key: "invoice_date",

      dataIndex: "invoice_date",

    },



    {

      title: "Due Date",

      key: "due_date",

      dataIndex: "due_date",

    },

    {

      title: "Description",

      key: "description",

      dataIndex: "description",

      width: 200,

      render: (text?: string) => {

        if (!text) return <Tag color="default">N/A</Tag>;

        return <TwoLineClampWithTooltip text={text} />;

      },

    },

    {

      title: "Status",

      dataIndex: "invoice_status",

      key: "invoice_status",

      width: 100,

      render: (status: string, record: any) => {

        const menu = (

          <div

            className="p-2 bg-white shadow-lg rounded-md w-[160px] flex flex-col"

            style={{ maxHeight: 220 }}

          >

            <div className="flex-1 overflow-y-auto">

              {invoiceStatusOptions.map((item) => (

                <div

                  key={item}

                  className="p-1 hover:bg-gray-100 cursor-pointer flex items-center"

                  onClick={() => handleInvoiceStatusChange(record, item)}

                >

                  {renderInvoiceStatusTag(item)}

                </div>

              ))}

            </div>

          </div>

        );



        return (

          <Dropdown overlay={menu} trigger={["click"]}>

            <span

              className="cursor-pointer"

              onClick={(e) => e.stopPropagation()}

            >

              {updatingInvoiceId === record._id ? (

                <Spin size="small" />

              ) : (

                renderInvoiceStatusTag(status)

              )}

            </span>

          </Dropdown>

        );

      },

    },



    //     {

    //   title: "Payment Link",

    //   key: "payment_link",

    //   dataIndex: "payment_link",

    //   render: (text) => <a href={text} target="_blank" rel="noopener noreferrer">{text}</a>

    // },

    {

      title: "Copy",

      key: "Copyinvoice",

      width: 100,

      align: "center" as const,

      render: (_: any, record: InvoiceRecord) => (

        <div className="flex items-center justify-center">

          <Tooltip title="Copy Invoice">

            <button

              onClick={() => {

                closeAllDropdowns();

                navigate(`/invoice/copy/${record._id}`);

              }}

              className="w-7 h-7 rounded-full bg-gradient-to-br from-sky-500 to-sky-700

                shadow-[0_4px_12px_rgba(14,165,233,0.3)]

                hover:shadow-[0_6px_16px_rgba(14,165,233,0.4)]

                active:translate-y-[1px] active:shadow-none

                text-white flex items-center justify-center

                transition-all duration-200 group"

            >

              <FaCopy size={12} className="group-hover:scale-110 transition-transform" />

            </button>

          </Tooltip>

        </div>

      ),

    },

    {

      title: "Send Email",

      key: "sendEmail",

      width: 100,

      align: "center",

      render: (_: any, record: any) => (

        <div className="flex items-center justify-center">

          <Tooltip title="Send Email">

            <button

              onClick={(e) => {

                e.preventDefault();

                handleSendInvoiceEmail(record);

              }}

              className="w-7 h-7 rounded-full bg-gradient-to-br from-emerald-400 to-green-600 

                       shadow-[0_4px_12px_rgba(34,197,94,0.3)] 

                       hover:shadow-[0_6px_16px_rgba(34,197,94,0.4)] 

                       active:translate-y-1 active:shadow-none 

                       text-white flex items-center justify-center transition-all duration-200 group"

              //title="Send Email"

            >

              <svg

                width="16"

                height="16"

                viewBox="0 0 24 24"

                fill="none"

                className="group-hover:scale-110 transition-transform"

              >

                <path

                  d="M4 6H20V18H4V6ZM4 6L12 13L20 6"

                  stroke="currentColor"

                  strokeWidth="2"

                  strokeLinecap="round"

                  strokeLinejoin="round"

                />

              </svg>

            </button>

          </Tooltip>

        </div>

      ),

    },

    {

      title: "Download PDF",

      key: "downloadPdf",

      width: 100,

      align: "center",

      render: (_: any, record: InvoiceRecord) => (

        <div className="flex items-center justify-center">

          <Tooltip title="Download PDF">

            <button

              onClick={() => downloadInvoicePdf(record)}

              className="w-7 h-7 rounded-full bg-gradient-to-br from-emerald-500 to-emerald-700

                        shadow-[0_4px_12px_rgba(16,185,129,0.3)]

                        hover:shadow-[0_6px_16px_rgba(16,185,129,0.4)]

                        active:translate-y-[1px] active:shadow-none

                        text-white flex items-center justify-center

                        transition-all duration-200 group"

            >

              <FaDownload

                size={12}

                className="group-hover:scale-110 transition-transform"

              />

            </button>

          </Tooltip>

        </div>

      ),

    },

    {

      title: "Action",

      dataIndex: "action",

      key: "action",

      width: 150,

      align: "center",

      render: (_: any, record: InvoiceRecord) => (

        <div

          className="d-flex"

          style={{ gap: "8px", alignItems: "center", justifyContent: "center" }}

        >

          <Tooltip title="Edit">

            <button

              onClick={() => {

                closeAllDropdowns();

                navigate(`/invoice/edit/${record._id}`);

                editInvoice(record);

              }}

              className="w-7 h-7 rounded-full bg-gradient-to-br from-indigo-500 to-purple-600 

                            shadow-[0_4px_12px_rgba(139,92,246,0.3)] 

                            hover:shadow-[0_6px_16px_rgba(139,92,246,0.4)] 

                            active:translate-y-[1px] active:shadow-none 

                            text-white flex items-center justify-center 

                            transition-all duration-200 ease-in-out group"

            >

              <FaPen

                className="group-hover:scale-110 transition-transform duration-200"

                size={12}

              />

            </button>

          </Tooltip>



          {hasPermission("customers", "delete") && (

            <Tooltip title="Delete">

              <button

                onClick={() => {

                  closeAllDropdowns();

                  setDeleteId(record._id);

                }}

                className="w-7 h-7 rounded-full bg-gradient-to-br from-rose-500 to-rose-700 

                              shadow-[0_4px_12px_rgba(244,63,94,0.3)] 

                              hover:shadow-[0_6px_16px_rgba(244,63,94,0.4)] 

                              active:translate-y-1 active:shadow-none 

                              text-white flex items-center justify-center 

                              transition-all duration-200 group"

              >

                <FaTrashAlt

                  className="group-hover:scale-110 transition-transform"

                  size={12}

                />

              </button>

            </Tooltip>

          )}

        </div>

      ),

    },

  ];



  // Filtered data by search textx

  const filteredData = dataSource.filter((item) => {

    const customerName = getCustomerDisplayName(item.customer_name, item);

    const searchData = (customerName.toString().toLowerCase() || "").includes(

      searchText.toString().toLowerCase(),

    );

    // const filteredMethodData = filteredMethod ? item.method === filteredMethod : true;



    const filteredMonthData = selectedMonth

      ? (() => {

          const invoiceDate = dayjs(

            item.invoice_date,

            ["DD-MM-YYYY", "YYYY-MM-DD", "D-M-YYYY"],

            true,

          );



          if (!invoiceDate.isValid()) {

            return false;

          }



          return invoiceDate.isSame(selectedMonth, "month");

        })()

      : true;



    const statusMatch = selectedStatusFilter

      ? (item.invoice_status || "drafted").toLowerCase() ===

        selectedStatusFilter.toLowerCase()

      : true;



    return searchData && filteredMonthData && statusMatch;

  });



  const savedTabData = filteredData.filter((item) => {

    const status = String(item.invoice_status || "drafted").toLowerCase();

    return status !== "drafted";

  });



  const draftTabData = filteredData.filter((item) => {

    const status = String(item.invoice_status || "drafted").toLowerCase();

    return status === "drafted";

  });



  const tabFilteredData = activeTab === "draft" ? draftTabData : savedTabData;



  const draftDisplayNumberMap = buildDraftDisplayNumberMap(

    dataSource,

    dayjs().format("YYYY"),

  );



  const orderedTabFilteredData =

    activeTab === "draft"

      ? [...tabFilteredData].sort((a, b) => {

          const aDraftSequence = draftDisplayNumberMap.get(a._id) ?? 0;

          const bDraftSequence = draftDisplayNumberMap.get(b._id) ?? 0;



          if (bDraftSequence !== aDraftSequence) {

            return bDraftSequence - aDraftSequence;

          }



          const aUpdatedAt = new Date(

            a.updatedAt || a.createdAt || 0,

          ).getTime();

          const bUpdatedAt = new Date(

            b.updatedAt || b.createdAt || 0,

          ).getTime();



          return bUpdatedAt - aUpdatedAt;

        })

      : tabFilteredData;



  // Calculate total amount

  const totalAmount = orderedTabFilteredData.reduce(

    (acc, item) => acc + getInrCurrencyAmount(item),

    0,

  );



  const pageSize = 10; // records per page



  const currentPage = activeTab === "draft" ? draftPage : savedPage;

  const paginatedData = orderedTabFilteredData.slice(

    (currentPage - 1) * pageSize,

    currentPage * pageSize,

  );



  useEffect(() => {

    fetchInvoice();



    if (!hasInvoiceAutoDraftActivity()) {

      return;

    }



    const refreshTimers = [1000, 2500].map((delay) =>

      window.setTimeout(() => {

        fetchInvoice();



        if (delay === 2500) {

          clearInvoiceAutoDraftCompleted();

        }

      }, delay),

    );



    return () => {

      refreshTimers.forEach((timer) => window.clearTimeout(timer));

    };

  }, [savedPage, draftPage, activeTab, searchText, selectedMonth]);



  return (

    <div className="p-2 bg-gray-100 min-h-screen">

      <div className="m-2 mb-4">

        <div

          style={{

            display: "flex",

            alignItems: "center",

            justifyContent: "space-between",

            flexWrap: "wrap",

            gap: "12px",

          }}

        >

          {/* Left side - Title and Total Amount */}

          <div

            style={{

              display: "flex",

              alignItems: "center",

              gap: "16px",

              flexShrink: 0,

            }}

          >

            <h2

              style={{

                fontSize: "24px",

                fontWeight: 600,

                margin: 0,

                whiteSpace: "nowrap",

                color: "#111827",

              }}

            >

              Invoices

            </h2>



            {/* Total Amount Card */}

            <div

              style={{

                background: "white",

                borderRadius: "8px",

                boxShadow: "0 2px 8px rgba(0,0,0,0.08)",

                padding: "4px 12px",

                display: "flex",

                height: "70px",

                alignItems: "center",

                gap: "8px",

              }}

            >

              <FcMoneyTransfer style={{ fontSize: "30px" }} />

              <span>Total Amounts:</span>

              <span

                style={{ fontSize: "22px", fontWeight: 600, color: "#10b981" }}

              >

                ₹{formatAmount(totalAmount)}

              </span>

            </div>

          </div>



          {/* RIGHT SIDE — Filters + Search + Add */}

          <div

            style={{

              display: "flex",

              alignItems: "center",

              gap: "8px",

              flexWrap: "wrap",

              flex: "1 1 auto",

              justifyContent: "flex-end",

            }}

          >

            {/* Month-Year Filter */}

            <DatePicker

              picker="month"

              placeholder="Select Month"

              format="MMM YYYY"

              value={selectedMonth}

              onChange={(date) => {

                setSelectedMonth(date);

                setDraftPage(1);

              }}

              allowClear

              style={{ width: 130, height: "33px" }}

              size="large"

            />



            {/* Status Filter */}

            <Select

              placeholder="Status"

              value={selectedStatusFilter || undefined}

              onChange={(val) => {

                setSelectedStatusFilter(val || "");

                setSavedPage(1);

                setDraftPage(1);

              }}

              allowClear

              style={{ width: 120, height: 33 }}

            >

              <Option value="drafted">Drafted</Option>

              <Option value="sent">Sent</Option>

              <Option value="cleared">Cleared</Option>

            </Select>



            {/* Search Box */}

            <Input

              placeholder="Search..."

              prefix={<SearchOutlined />}

              value={searchText}

              onChange={(e) => setSearchText(e.target.value)}

              allowClear

              style={{ width: 190, minWidth: 150, height: 33 }}

            />

          </div>



          {/* Add Invoice Button */}

          <Button

            type="primary"

            onClick={() => {

              closeAllDropdowns();

              navigate("/invoice/add");

            }}

            style={{ background: "#001529", height: "33px" }}

          >

            <RiAddBoxFill className="button-icon" />

            Add

          </Button>

        </div>

      </div>



      {/* Invoice Log Modal */}

      <Modal

        title={

          <div className="flex justify-between items-center w-full">

            <span className="text-xl font-bold">Invoice Log</span>

            <Input

              placeholder="🔍 Search logs..."

              allowClear

              value={logSearchText}

              onChange={(e) => {

                setLogSearchText(e.target.value);

                if (currentInvoiceLogId) {

                  handleViewInvoiceLogs(currentInvoiceLogId, 1, e.target.value);

                }

              }}

              className="w-64 rounded text-sm mr-10"

            />

          </div>

        }

        open={isLogModalOpen}

        onCancel={() => setIsLogModalOpen(false)}

        footer={null}

        width={650}

        style={{

          bottom: 20,

          top: 20,

          maxHeight: "calc(100vh - 30px)",

          margin: "0 auto",

          position: "relative",

        }}

        bodyStyle={{

          overflowY: "auto",

          fontFamily: "inter, sans-serif",

        }}

        styles={{

          header: {

            borderBottom: "1px solid #e0e0e0",

            padding: "12px",

            position: "sticky",

            top: 0,

            backgroundColor: "white",

          },

          content: {

            padding: 0,

            overflow: "hidden",

          },

        }}

      >

        <div ref={modalScrollRef} className="">

          <div className="elements">

            <table className="w-full bg-white shadow-md rounded-lg">

              <thead>

                <tr className="bg-gray-200">

                  <th className="border p-3 text-left w-1/3">

                    <ClockCircleOutlined className="mr-2" /> Updated At

                  </th>

                  <th className="border p-3 text-left">

                    <MessageOutlined className="mr-2" /> Message

                  </th>

                </tr>

              </thead>



              <tbody>

                {selectedInvoiceLogs.length > 0 ? (

                  selectedInvoiceLogs.map((log) => {

                    const formattedTimestamp = dayjs(log.createdAt)

                      .utc()

                      .local()

                      .format("DD-MM-YYYY HH:mm");



                    const hasHTML = /<[^>]*>/.test(log.message);



                    if (hasHTML) {

                      const plainText = log.message

                        .replace(/<[^>]*>/g, " ")

                        .replace(/\s+/g, " ")

                        .trim();

                      const isLong = plainText.length > 110;

                      const displayText = isLong

                        ? plainText.substring(0, 110) + "..."

                        : plainText;



                      return (

                        <tr

                          key={log._id}

                          className="hover:bg-gray-100 transition"

                        >

                          <td className="border p-3">{formattedTimestamp}</td>

                          <td className="border p-3 max-w-xl align-top">

                            {isLong ? (

                              <Tooltip

                                title={

                                  <div

                                    dangerouslySetInnerHTML={{

                                      __html: log.message,

                                    }}

                                    className="description-tooltip-content"

                                  />

                                }

                                classNames={{ root: "plain-tooltip" }}

                                mouseEnterDelay={0.3}

                                placement="top"

                                overlayStyle={{

                                  maxWidth: "500px",

                                  maxHeight: "400px",

                                  overflowY: "auto",

                                }}

                              >

                                <span style={{ cursor: "pointer" }}>

                                  {log.message}

                                </span>

                              </Tooltip>

                            ) : (

                              <span style={{ cursor: "pointer" }}>

                                {log.message}

                              </span>

                            )}

                          </td>

                        </tr>

                      );

                    } else {

                      const isLong = log.message.length > 110;

                      const displayText = isLong

                        ? log.message.substring(0, 110) + "..."

                        : log.message;



                      return (

                        <tr

                          key={log._id}

                          className="hover:bg-gray-100 transition"

                        >

                          <td className="border p-3">{formattedTimestamp}</td>

                          <td className="border p-3 max-w-xl">

                            {isLong ? (

                              <Tooltip

                                title={log.message}

                                placement="topLeft"

                                color="#CCCCCC"

                                overlayInnerStyle={{

                                  color: "#000",

                                  padding: "12px",

                                  maxWidth: "500px",

                                  minWidth: "400px",

                                  maxHeight: "400px",

                                }}

                              >

                                <span

                                  style={{

                                    display: "-webkit-box",

                                    WebkitBoxOrient: "vertical",

                                    WebkitLineClamp: 2,

                                    overflow: "hidden",

                                    textOverflow: "ellipsis",

                                    whiteSpace: "normal",

                                    wordBreak: "break-word",

                                    maxWidth: "350px",

                                    cursor: "pointer",

                                  }}

                                >

                                  {displayText}

                                </span>

                              </Tooltip>

                            ) : (

                              <span

                                style={{

                                  display: "-webkit-box",

                                  WebkitBoxOrient: "vertical",

                                  WebkitLineClamp: 2,

                                  overflow: "hidden",

                                  textOverflow: "ellipsis",

                                  whiteSpace: "normal",

                                  wordBreak: "break-word",

                                  maxWidth: "350px",

                                  cursor: "pointer",

                                }}

                              >

                                {displayText}

                              </span>

                            )}

                          </td>

                        </tr>

                      );

                    }

                  })

                ) : (

                  <tr>

                    <td

                      colSpan={2}

                      className="border p-3 text-center text-gray-500"

                    >

                      No logs available

                    </td>

                  </tr>

                )}

              </tbody>

            </table>

          </div>

          <div className="footer-modals" />

          <div className="p-3">

            <div className="d-flex justify-content-end">

              <Pagination

                current={logsPagination.current}

                pageSize={logsPagination.pageSize}

                total={logsPagination.total}

                onChange={(page) => {

                  if (currentInvoiceLogId) {

                    handleViewInvoiceLogs(

                      currentInvoiceLogId,

                      page,

                      logSearchText,

                    );

                  }

                }}

                showSizeChanger={false}

              />

            </div>

          </div>

        </div>

      </Modal>



      {/* Delete Confirmation Modal */}

      <Modal

        open={!!deleteId}

        onOk={handleDelete}

        onCancel={() => setDeleteId(null)}

        okText="Yes"

        cancelText="No"

        width={500}

        centered={false}

        destroyOnClose

        className="custom-modal"

        style={{

          bottom: 20,

          top: "10vw",

          maxHeight: "calc(100vh - 30px)",

          margin: "0 auto",

          position: "relative",

        }}

        title={

          <div

            style={{

              marginLeft: "11px",

              width: "100%",

              paddingRight: 20,

            }}

          >

            Confirmation

          </div>

        }

        okButtonProps={{

          style: {

            backgroundColor: "#ff4d4f",

            borderColor: "#ff4d4f",

            color: "white",

          },

        }}

        bodyStyle={{

          padding: "22px",

          overflowY: "auto",

          fontFamily: "inter, sans-serif",

        }}

        styles={{

          header: {

            borderBottom: "1px solid #e0e0e0",

            padding: "12px",

            position: "sticky",

            top: 0,

            backgroundColor: "white",

          },

          content: {

            padding: 0,

            overflow: "hidden",

          },

          footer: {

            borderTop: "1px solid #e0e0e0",

            padding: "12px",

            position: "sticky",

            top: 0,

            backgroundColor: "white",

          },

        }}

      >

        <p>Are you sure you want to delete this Invoice?</p>

      </Modal>



      <Card className="">

        <div

          className="scrollbar-hide custom-scroll-table"

          style={{ overflowX: "auto" }}

        >

          <Tabs

            activeKey={activeTab === "saved" ? "1" : "2"}

            className="mb-0"

            onSelect={(key) => {

              if (key === "1") {

                setActiveTab("saved");

                setSavedPage(1);

              }



              if (key === "2") {

                setActiveTab("draft");

                setDraftPage(1);

              }

            }}

          >

            <Tab eventKey="1" title={`Save (${savedTabData.length})`}>

              <Table

                scroll={{ x: "max-content" }}

                columns={columns}

                dataSource={activeTab === "saved" ? paginatedData : []}

                loading={loading}

                rowKey="_id"

                pagination={{

                  pageSize: 10,

                  current: activeTab === "saved" ? savedPage : 1,

                  onChange: (pageNumber) => setSavedPage(pageNumber),

                  showSizeChanger: false,

                  total: savedTabData.length,

                }}

                bordered={false}

                className="invoice-table"

              />

            </Tab>

            <Tab eventKey="2" title={`Draft (${draftTabData.length})`}>

              <Table

                scroll={{ x: "max-content" }}

                columns={columns}

                dataSource={activeTab === "draft" ? paginatedData : []}

                loading={loading}

                rowKey="_id"

                pagination={{

                  pageSize: 10,

                  current: activeTab === "draft" ? draftPage : 1,

                  onChange: (pageNumber) => setDraftPage(pageNumber),

                  showSizeChanger: false,

                  total: draftTabData.length,

                }}

                bordered={false}

                className="invoice-table"

              />

            </Tab>

          </Tabs>

        </div>

      </Card>



      {currentTask && (

        <EditInvoiceModel

          visible={isEditModalVisible}

          id={currentTask?._id}

          onClose={() => {

            setIsEditModalVisible(false);

            setCurrentTask(null);

          }}

          onTaskCreated={function (): void {

            setCurrentTask(null);

          }}

          onSuccess={() => {

            setIsEditModalVisible(false);

            setCurrentTask(null);

            fetchInvoice();

          }}

        />

      )}



      {currentTask && (

        <CopyInvoiceModel

          visible={isCopyModalVisible}

          id={currentTask?._id}

          onClose={() => {

            setIsCopyModalVisible(false);

            setCurrentTask(null);

          }}

          onTaskCreated={function (): void {

            setCurrentTask(null);

          }}

          onSuccess={() => {

            setIsCopyModalVisible(false);

            setCurrentTask(null);

            fetchInvoice();

          }}

        />

      )}



      {/* Add to Receipt Confirm Modal */}

      <Modal

        open={!!invoiceForReceipt && !addReceiptVisible}

        onOk={() => {

          setAddReceiptVisible(true);

        }}

        onCancel={() => setInvoiceForReceipt(null)}

        okText="Yes, Add to Receipt"

        cancelText="Cancel"

        width={420}

        centered

        title="Add to Receipt"

        okButtonProps={{

          style: { backgroundColor: "#10B981", borderColor: "#10B981", padding: "24px" },

        }}

      >

        <p>

          Are you sure you want to add details from this invoice to a receipt?

        </p>

      </Modal>



      {/* Add Receipt Modal prefilled from invoice */}

      {invoiceForReceipt && addReceiptVisible && (

        <AddReceiptsModel

          visible={addReceiptVisible}

          onClose={() => {

            setAddReceiptVisible(false);

            setInvoiceForReceipt(null);

          }}

          onTaskCreated={() => {

            setAddReceiptVisible(false);

            setInvoiceForReceipt(null);

          }}

          prefillData={{

            customer_id: (() => {

              const c = invoiceForReceipt.customer_name;

              if (c && typeof c === "object" && c._id) return c._id;

              const ci = invoiceForReceipt.customer_id;

              if (ci && typeof ci === "object" && ci._id) return ci._id;

              if (c && typeof c === "string" && c.length === 24) return c;

              return undefined;

            })(),

            project_id: (() => {

              const p = invoiceForReceipt.project;

              if (p && typeof p === "object" && p._id) return p._id;

              if (p && typeof p === "string") return p;

              return undefined;

            })(),

            amount: Math.floor(getInrCurrencyAmount(invoiceForReceipt)),

            description: (invoiceForReceipt.description || "")

              .replace(/<[^>]*>/g, " ")

              .replace(/\s+/g, " ")

              .trim(),

            authorize: true,

          }}

        />

      )}



      {/* Send Email Modal */}

      <Modal

        title={

          <div

            style={{

              color: "#4b5563",

              fontFamily: "inter, sans-serif",

              fontWeight: 500,

              fontSize: "20px",

            }}

          >

            Send Invoice Email

          </div>

        }

        open={isEmailModalVisible}

        onCancel={() => {

          setIsEmailModalVisible(false);

          setSendEmailRecord(null);

          setSelectedEmailTemplate(null);

          setEmailPreview(null);

          setEmailTemplateLoading(false);

          setEmailTemplateError(null);

        }}

        footer={null}

        width={800}

        centered

        destroyOnClose

        className="custom-modal"

        bodyStyle={{

          overflowY: "auto",

          fontFamily: "inter, sans-serif",

        }}

        style={{ bottom: 20, top: 20, margin: "0 auto", position: "relative" }}

        styles={{

          header: {

            padding: "12px",

            position: "sticky",

            top: 0,

            backgroundColor: "#f1f5ffff",

          },

          content: { padding: 0, overflow: "visible" },

          body: {

            minHeight: "520px",

            fontFamily: "inter, sans-serif",

          },

        }}

      >

        <Form

          form={emailForm}

          layout="horizontal"

          labelCol={{ span: 5 }}

          wrapperCol={{ span: 19 }}

          colon={false}

          onFinish={handleConfirmEmailSend}

          labelAlign="left"

          className="email-modal-form"

        >

          <div className="elements" style={{ paddingTop: 4 }}>

            <style>{`

              .email-modal-form .ant-form-item-label {

                display: flex;

                align-items: center;

              }

              .email-modal-form .ant-form-item-label > label {

                height: 32px;

                align-items: center;

              }

              .email-modal-form .ant-form-item {

                margin-bottom: 24px;

              }

            `}</style>

            <Form.Item

              label={

                <span

                  style={{

                    color: "#4b5563",

                    fontFamily: "inter, sans-serif",

                    fontSize: "14px",

                    fontWeight: 500,

                    paddingLeft: "15px",

                    lineHeight: "32px",

                    display: "flex",

                    alignItems: "center",

                  }}

                >

                  To Email{" "}

                  <span style={{ color: "#ef4444", marginLeft: 4 }}>*</span>

                </span>

              }

              name="to"

              required={false}

              normalize={(value) => value?.toLowerCase()}

              rules={[

                { required: true, message: "Please enter recipient email" },

                { type: "email", message: "Please enter a valid email" },

              ]}

            >

              <Input className="Allinput" placeholder="recipient@example.com" />

            </Form.Item>



            <Form.Item

              label={

                <span

                  style={{

                    color: "#4b5563",

                    fontFamily: "inter, sans-serif",

                    fontSize: "14px",

                    fontWeight: 500,

                    paddingLeft: "15px",

                    lineHeight: "32px",

                    display: "flex",

                    alignItems: "center",

                  }}

                >

                  CC

                </span>

              }

              name="cc"

              normalize={(value) => value?.toLowerCase()}

              rules={[{ type: "email", message: "Please enter a valid email" }]}

            >

              <Input

                className="Allinput"

                placeholder="cc@example.com (optional)"

              />

            </Form.Item>



            {/* Email Type + Preview side by side */}

            <div

              style={{

                display: "flex",

                gap: "16px",

                alignItems: "flex-start",

                height: "320px",

              }}

            >

              {/* Left: Email Type */}

              <div style={{ flex: "0 0 220px", height: "320px" }}>

                <Form.Item

                  label={

                    <span

                      style={{

                        color: "#4b5563",

                        fontFamily: "inter, sans-serif",

                        fontSize: "14px",

                        fontWeight: 500,

                        paddingLeft: "15px",

                        lineHeight: "32px",

                        display: "flex",

                        alignItems: "center",

                      }}

                    >

                      Email Type{" "}

                      <span style={{ color: "#ef4444", marginLeft: 4 }}>*</span>

                    </span>

                  }

                  name="reminderType"

                  required={false}

                  rules={[{ required: true }]}

                  labelCol={{ span: 24 }}

                  wrapperCol={{ span: 24 }}

                >

                  <Radio.Group

                    className="flex flex-col gap-2"

                    onChange={(e) => handleEmailTypeChange(e.target.value)}

                  >

                    <Radio value="standard">Standard Invoice Email</Radio>

                    <Radio value="first">1st Payment Reminder</Radio>

                    <Radio value="second">2nd Payment Reminder</Radio>

                  </Radio.Group>

                </Form.Item>

              </div>



              {/* Right: Email Preview */}

              <div style={{ flex: 1, minWidth: 0, height: "320px" }}>

                <div

                  style={{

                    padding: "16px",

                    backgroundColor: "#f9fafb",

                    borderRadius: "8px",

                    border: "1px solid #e5e7eb",

                    height: "100%",

                    overflowY: "hidden",

                    display: "flex",

                    flexDirection: "column",

                  }}

                >

                  {emailTemplateLoading && (

                    <div

                      style={{

                        display: "flex",

                        alignItems: "center",

                        justifyContent: "center",

                        minHeight: "320px",

                      }}

                    >

                      <Spin size="small" style={{ marginRight: "8px" }} />

                      <span style={{ color: "#6b7280", fontSize: "14px" }}>

                        Loading email template...

                      </span>

                    </div>

                  )}



                  {emailTemplateError && !emailTemplateLoading && (

                    <div

                      style={{

                        padding: "16px",

                        backgroundColor: "#fef2f2",

                        borderRadius: "8px",

                        border: "1px solid #fecaca",

                      }}

                    >

                      <div style={{ color: "#dc2626", fontSize: "14px" }}>

                        <strong>Error:</strong> {emailTemplateError}

                      </div>

                      <div

                        style={{

                          color: "#6b7280",

                          fontSize: "12px",

                          marginTop: "4px",

                        }}

                      >

                        Please ensure the email template exists in the system.

                      </div>

                    </div>

                  )}



                  {emailPreview && !emailTemplateLoading && (

                    <>

                      <div

                        style={{

                          fontWeight: 600,

                          color: "#374151",

                          marginBottom: "12px",

                          fontSize: "14px",

                        }}

                      >

                        Email Preview

                      </div>

                      <div style={{ marginBottom: "12px" }}>

                        <div

                          style={{

                            fontSize: "12px",

                            color: "#6b7280",

                            marginBottom: "4px",

                          }}

                        >

                          Subject

                        </div>

                        <div

                          style={{

                            fontSize: "14px",

                            color: "#1f2937",

                            fontWeight: 500,

                            padding: "8px 12px",

                            backgroundColor: "#fff",

                            borderRadius: "6px",

                            border: "1px solid #d1d5db",

                          }}

                        >

                          {emailPreview.subject}

                        </div>

                      </div>

                      <div

                        style={{

                          display: "flex",

                          flexDirection: "column",

                          flex: 1,

                          minHeight: 0,

                        }}

                      >

                        <div

                          style={{

                            fontSize: "12px",

                            color: "#6b7280",

                            marginBottom: "4px",

                          }}

                        >

                          Body

                        </div>

                        <div

                          style={{

                            fontSize: "14px",

                            color: "#1f2937",

                            padding: "12px",

                            backgroundColor: "#fff",

                            borderRadius: "6px",

                            border: "1px solid #d1d5db",

                            flex: 1,

                            overflowY: "auto",

                            minHeight: 0,

                          }}

                          dangerouslySetInnerHTML={{

                            __html: emailPreview.body,

                          }}

                        />

                      </div>

                    </>

                  )}

                </div>

              </div>

            </div>

          </div>



          <Row justify="end">

            <Col xs={24} className="d-flex justify-content-end me-4">

              <div style={{ marginTop: 20, display: "flex", gap: 10 }}>

                <button

                  type="button"

                  className="allcanclebutton"

                  onClick={() => {

                    setIsEmailModalVisible(false);

                    setSendEmailRecord(null);

                    setSelectedEmailTemplate(null);

                    setEmailPreview(null);

                    setEmailTemplateLoading(false);

                    setEmailTemplateError(null);

                  }}

                  disabled={emailModalLoading}

                >

                  Cancel

                </button>

                <button

                  type="submit"

                  className="allsubmitebutton"

                  disabled={emailModalLoading}

                >

                  {emailModalLoading ? "Sending..." : "Send Email"}

                </button>

              </div>

            </Col>

          </Row>

        </Form>

      </Modal>

    </div>

  );

};



export const INVOICES_TABLE_COLUMNS = [

  "invoice_number",

  "customer_name",

  "grand_total",

  "description",

  "currency",

  "invoice_date",

  "due_date",

  "invoice_status",

];



export default InvoicePage;

